import { notifications } from '@mantine/notifications';

export const notifyError = (msg, subMsg = '') => {
  notifications.show({
    title: msg,
    message: subMsg,
    color: '#FFBFC5',
  });
};

export const notifySuccess = (msg, subMsg = '') => {
  notifications.show({
    title: msg,
    message: subMsg,
  });
};

export const notifyWarn = (msg, subMsg = '') => {
  notifications.show({
    title: msg,
    message: subMsg,
  });
};
